<div class="location-selection-panel">
  <div class="universal">
    <span>Select a Location</span>

    <div class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </div>
  </div>

  <span class="custom-loc-header"
    ><span class="custom-loc-title">Custom Location List</span>
    <span class="manage-lists" (click)="showManageList()"
      >Manage Lists...</span
    ></span
  >
  <div class="custom-loc-list">
    @for (listGroup of customList$ | async; track listGroup) {
    <div class="custom-loc">
      @for (list of listGroup; track list) {
      <div (click)="selectCustomList(list)">
        {{ list.listName }}
      </div>
      }
    </div>
    }
  </div>
  <div class="continent-location">
    <div>Locations by Continent</div>
    <span [matMenuTriggerFor]="contMenu" class="continent-menu"
      >{{ (continent$ | async)?.text | titlecase }}
      <mat-icon>expand_more</mat-icon></span
    >
  </div>
  <span class="regions">
    @if ((continent$ | async)?.id === 'NA' && isLoaded) {
    <span>
      <span
        class="na-regions"
        [ngClass]="{
          'restricted-regions':
            !selectedISORegions.length || !selectedEIARegions.length
        }"
      >
        <span class="agg">
          <span (click)="selectRegion({ regionName: 'All Regions' })">
            All Aggregates
          </span>
          <span
            (click)="
              selectRegion(
                { regionName: 'ISO Regions' },
                !selectedISORegions.length
              )
            "
            [ngClass]="{
              disabled: !selectedISORegions.length
            }"
          >
            ISO Aggregates @if (!selectedISORegions.length) {
            <firebird-web-icon
              class="lock-icon"
              name="lock"
              width="18px"
              height="16px"
            >
            </firebird-web-icon>
            }
          </span>
          <span
            (click)="
              selectRegion(
                { regionName: 'EIA Regions' },
                !selectedEIARegions.length
              )
            "
            [ngClass]="{
              disabled: !selectedEIARegions.length
            }"
          >
            EIA Aggregates @if (!selectedEIARegions.length) {
            <firebird-web-icon
              class="lock-icon"
              name="lock"
              width="18px"
              height="16px"
            >
            </firebird-web-icon>
            }
          </span>
          <span (click)="selectRegion({ regionName: 'All Cities' })">
            All Cities
          </span>
        </span>
        @if (selectedISORegions.length) {
        <span>
          <div class="iso-title">ISO Cities by Region</div>
          <span class="iso-regions">
            @for (region of selectedISORegions; track region) {
            <span (click)="selectRegion(region)">
              {{ region.regionName }}
            </span>
            }
          </span>
        </span>
        } @if (selectedEIARegions.length) {
        <span>
          <div class="iso-title">EIA Cities By Region</div>
          <span class="eia-cities">
            @for (region of selectedEIARegions; track region) {
            <span (click)="selectRegion(region)">
              {{ region.regionName }}
            </span>
            }
          </span>
        </span>
        }
      </span>
    </span>
    } @if ((continent$ | async)?.id === 'EUR') {
    <span>
      <div class="eur-regions">
        <span class="agg">
          <span (click)="selectRegion({ regionName: 'All Regions' })"
            >All Aggregates</span
          >
          <span (click)="selectRegion({ regionName: 'All Cities' })"
            >All Cities</span
          >
        </span>
        @for (regionList of selectedISORegionsByChunks; track regionList) {
        <span class="non-agg-eur-regions">
          @for (region of regionList; track region) {
          <span (click)="selectRegion(region)" class="region-item">
            {{ region.regionName }}
          </span>
          }
        </span>
        }
      </div>
    </span>
    } @if ((continent$ | async)?.id === 'ASIA') {
    <span>
      <div class="asia-regions">
        <span class="agg">
          <span (click)="selectRegion({ regionName: 'All Regions' })"
            >All Aggregates</span
          >
          <span (click)="selectRegion({ regionName: 'All Cities' })"
            >All Cities</span
          >
        </span>
        @for (regionList of selectedISORegionsByChunks; track regionList) {
        <span class="asia-non-agg-regions">
          @for (region of regionList; track region) {
          <span (click)="selectRegion(region)" class="asia-region-item">
            {{ region.regionName }}
          </span>
          }
        </span>
        }
      </div>
    </span>
    } @if ((continent$ | async)?.id === 'MEX') {
    <span>
      <span class="na-regions">
        <span class="agg">
          <span (click)="selectRegion({ regionName: 'All Regions' })">
            All Aggregates
          </span>
          <span (click)="selectRegion({ regionName: 'All Cities' })">
            All Cities
          </span>
        </span>
        <span>
          <span class="mex-city">
            @for (region of mexRegions; track region) {
            <span (click)="selectRegion(region)" class="city">{{
              region.regionName
            }}</span>
            }
          </span>
        </span>
      </span>
    </span>
    }
  </span>

  <mat-menu class="locations-menu-panel" #contMenu="matMenu">
    @for (continent of continents$ | async; track continent) {
    <div mat-menu-item>
      <div
        [hasViewPermission]="[continent.id || '']"
        (click)="changeContinent(continent)"
        [alignRight]="true"
        key="PoolSet"
      >
        {{ continent.text | titlecase }}
      </div>
    </div>
    }
  </mat-menu>
</div>
